export const BASE = {
  name: 'team',
  path: '/team',
};

export const LIST = {
  name: 'team.list',
  path: `${BASE.path}/list`,
};

export const INVITE_DEFAULT = {
  name: 'team.invite',
  path: `${BASE.path}/invite`,
};

export const INVITE = {
  name: 'team.invite',
  path: `${BASE.path}/invite/:organizationId`,
};
